// extracted by mini-css-extract-plugin
module.exports = {"headerIcon":"WishlistButton_headerIcon__2u_4J","wishlistImg":"WishlistButton_wishlistImg__Pbct_","headerTextIcon":"WishlistButton_headerTextIcon__2O23D"};